import { NgModule } from '@angular/core';
import { ChecklistListComponent } from './checklist-list.component';
import { ChecklistListItemColourIndicatorComponent } from './item-colour-indicator/item-colour-indicator.component';
import { ItemsListModule } from '@fi-app/components/items-list/items-list.module';
import { ChecklistListItemDueDateTimeComponent } from './item-due-date-time/item-due-date-time.component';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { CommonModule } from '@angular/common';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { ChecklistLitHeadItemColourIndicator } from './head-item-colour-indicator/head-item-colour-indicator.component';
import { ChecklistListViewComponent } from './checklist-list-view/checklist-list-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ChecklistListContainerComponent } from './checklist-list-container/checklist-list-container.component';
import { ChecklistListNavigationTabsComponent } from './checklist-list-navigation-tabs/checklist-list-navigation-tabs.component';
import { UIRouterModule } from '@uirouter/angular';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';

@NgModule({
    imports: [
        CommonModule,
        ItemsListModule,
        FiFormatDateModule,
        FiAppTextSharedModule,
        UtilitiesModule,
        UIRouterModule,
        MatButtonModule,
        MatIconModule,
        FiItemsListModule,
    ],
    declarations: [
        ChecklistListComponent,
        ChecklistListItemColourIndicatorComponent,
        ChecklistListItemDueDateTimeComponent,
        ChecklistLitHeadItemColourIndicator,
        ChecklistListViewComponent,
        ChecklistListContainerComponent,
        ChecklistListNavigationTabsComponent,
    ],
    exports: [ChecklistListComponent, ChecklistListViewComponent],
})
export class ChecklistListModule {}
